<div class="discussionSubtitle discussionSubtitleBg d-flex align-items-center justify-content-between" [ngClass]="classes ? classes : null">
  <div class="d-flex">
    <!--    <div class="cursor-pointer p-3" *ngIf="inChat" (click)="close()">
          <fa-icon icon="chevron-left"></fa-icon>
        </div>-->
    <div class="cursor-pointer">
      <p class="font-weight-bold m-1 mt-2 ">{{post?.title}}</p> <!-- [innerHTML]=element.name | truncate : 23"></p>-->
      <small class="mt-1">
        <sb-icon icon="plus"></sb-icon>&nbsp;
        <span [innerHTML]="util.passedTime(post?.createdAt, 'day')"
              [ngbTooltip]="post?.createdAt?.toString() | date: 'dd.MM.yy HH:mm'" container="body"></span>
        <sb-icon class="ml-4" icon="clock" *ngIf="post?.lastParticipation?.createdAt"></sb-icon>&nbsp;
        <span *ngIf="post?.lastParticipation?.createdAt"
              [innerHTML]="util.passedTime(post?.lastParticipation?.createdAt, 'day')"
              [ngbTooltip]="post?.lastParticipation?.createdAt?.toString() | date: 'dd.MM.yy HH:mm'"
              container="body"></span>

      </small>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <sb-avatar class="mr-2" [users]="post?[post?.createdBy]:[]" container="body"
               [ngbTooltip]="('lang.globals.createdBy' |translate )+': ' + post?.createdBy?.name"
               placement="left"></sb-avatar>
    <sb-avatar [users]="post?.participants" [ngbTooltip]="participant" placement="left" container="body"></sb-avatar>
  </div>
</div>
<ng-template #participant>
  <p class="m-0">{{'lang.globals.participants' | translate}}:</p>
  <p class="m-0" *ngFor="let user of post?.participants">
    {{user?.name}}
  </p>
</ng-template>

